import { FC, useMemo } from 'react';

import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { numberFormatter } from '../../../config/utils';

import styles from './SingleMultiplier.module.css';

interface ColorScheme {
  range: [number, number];
  btnValue: string;
}

interface SingleMultiplierProps {
  value: number | string;
  plain?: boolean;
}

const colorRanges: ColorScheme[] = [
  { range: [-Infinity, -1], btnValue: '0' },
  { range: [0, 2], btnValue: '1' },
  { range: [2, 5], btnValue: '2' },
  { range: [5, 10], btnValue: '3' },
  { range: [10, 100], btnValue: '4' },
  { range: [100, Infinity], btnValue: '5' },
];

const getColorScheme = (value: number): ColorScheme => {
  return colorRanges.find(({ range }) => value >= range[0] && value <= range[1]) || colorRanges[0];
};

// Note : The parent of this component should have some height and min-width properties but give max-width as max-content.

export const SingleMultiplier: FC<SingleMultiplierProps> = ({ value, plain }) => {
  const colorScheme = getColorScheme(Number(value));
  const { btnValue } = colorScheme;
  const locale = useSettingsSlice.currentLanguage();

  const formatedNumber = useMemo(() => {
    return numberFormatter(Number(value), locale);
  }, [locale, value]);

  const formattedMultiplier = formatedNumber;
  const mods = useModifiers(styles, 'btnValue', {
    [btnValue]: true,
    plain: plain,
  });

  return (
    <div className={`${styles.singleBox} ${mods}`}>
      {formattedMultiplier}
      <span>x</span>
    </div>
  );
};
